import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    fetch(`/api/posts/${slug}`)
      .then((r) => {
        if (r.status === 404) return Promise.reject("not_found");
        if (!r.ok) return Promise.reject("error");
        return r.json();
      })
      .then((data) => { setPost(data); setStatus("ready"); })
      .catch((reason) => setStatus(reason === "not_found" ? "not_found" : "error"));
  }, [slug]);

  if (status === "loading") {
    return <section className="section"><div className="loading"><div className="loading-spinner"></div>Loading…</div></section>;
  }
  if (status === "not_found") {
    return (
      <section className="section">
        <Link to="/blog" className="blog-back">← Back to blog</Link>
        <p className="blog-empty">Post not found.</p>
      </section>
    );
  }
  if (status === "error") {
    return <section className="section"><p className="blog-empty">Something went wrong.</p></section>;
  }

  return (
    <article className="section blog-article">
      <Link to="/blog" className="blog-back">← All posts</Link>
      <header className="blog-article-header">
        <time className="blog-article-date">
          {new Date(post.date).toLocaleDateString("en-US", {
            year: "numeric", month: "long", day: "numeric",
          })}
        </time>
        <h1 className="blog-article-title">{post.title}</h1>
        {post.tags?.length > 0 && (
          <div className="project-tech">
            {post.tags.map((t) => <span key={t} className="tech-tag">{t}</span>)}
          </div>
        )}
      </header>
      <div className="blog-article-body" dangerouslySetInnerHTML={{ __html: post.html }} />
    </article>
  );
}
